<template>
    <info-widget :collapsible="true" :is-expanded="expanded" @toggle_expand="expanded = !expanded">
        <template v-slot:title>Cash Requirements</template>
        <slot>
            <div class="p-2">
                <div v-if="status === 'computing'" class="p-3 text-center text-muted">
                    <i class="fa fa-spinner fa-spin mr-2"></i>
                </div>
                <div v-else-if="status === 'failed'" class="p-3 text-center text-muted">
                    Unable to compute cash requirements for this run.
                </div>
                <div v-else-if="cashRequirements">
                    <cash-requirements-section
                        heading="Electronic Withdrawals"
                        :accounts="electronicWithdrawals"
                        :check-date="checkDate"
                        empty-message="No electronic withdrawals for this run."
                    />
                    <cash-requirements-section
                        heading="Paper Checks"
                        :accounts="paperChecks"
                        :check-date="checkDate"
                        empty-message="No paper checks for this run."
                        class="mt-3"
                    />
                </div>
            </div>
        </slot>
    </info-widget>
</template>

<script>
import InfoWidget from '@/components/InfoWidget'
import CashRequirementsSection from './CashRequirementsSection'

export default {
    components: {InfoWidget: InfoWidget, CashRequirementsSection: CashRequirementsSection},
    props: ['cashRequirements', 'status', 'checkDate'],
    data() {
        return {
            expanded: true,
        }
    },
    computed: {
        electronicWithdrawals() {
            return (this.cashRequirements && this.cashRequirements.electronic_withdrawals) || []
        },
        paperChecks() {
            return (this.cashRequirements && this.cashRequirements.paper_checks) || []
        },
    },
}
</script>
